import { supabase } from "@/infrastructure/supabase/client";
import type { FeatureRequestCommentRow } from "@/infrastructure/supabase/database.types";

export interface CreateCommentInput {
  request_id: string;
  body: string;
  author_id: string;
  author_email: string | null;
}

export const featureRequestCommentsRepository = {
  async listForRequest(requestId: string): Promise<FeatureRequestCommentRow[]> {
    const { data, error } = await supabase
      .from("feature_request_comments")
      .select("*")
      .eq("request_id", requestId)
      .order("created_at", { ascending: true });
    if (error) throw error;
    return (data as FeatureRequestCommentRow[] | null) ?? [];
  },

  async create(input: CreateCommentInput): Promise<FeatureRequestCommentRow> {
    const { data, error } = await supabase
      .from("feature_request_comments")
      .insert({
        request_id: input.request_id,
        body: input.body,
        author_id: input.author_id,
        author_email: input.author_email,
      })
      .select("*")
      .single();
    if (error) throw error;
    return data as FeatureRequestCommentRow;
  },

  async remove(id: string): Promise<void> {
    const { error } = await supabase.from("feature_request_comments").delete().eq("id", id);
    if (error) throw error;
  },
};
